import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { useLocale } from '@/modules/locale/model/locale';
import { ROUTE_NAME_HOMEPAGE } from '@/modules/main/router';
import badwordService from '@/services/badword';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';

export default function () {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { localeSupportedOptions, getListSupported } = useLocale();
    const model = reactive({
        locale: null,
        hasData: false,
        content: ''
    });

    const validations = {
        content: { required },
        locale: { required }
    };

    const v$ = useVuelidate(validations, model);

    const beforeFetch = async () => {
        await getListSupported();
        if (!localeSupportedOptions.value.length) {
            router.push({ name: ROUTE_NAME_HOMEPAGE });
            return;
        }
    };

    const fetch = crudAction.executeAction({
        canExecute: () => model.locale != null,
        request: () => badwordService.get(model.locale),
        onSuccess: ({ data }) => {
            model.hasData = data?.length > 0;
            model.content = data;
        },
        onError: () => {
            model.hasData = false;
            model.content = '';
        },
        onFinally: () => v$.value.$reset()
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () => badwordService.update(model.locale, model.content),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: () => badwordService.remove(model.locale),
            onSuccess: fetch
        })
    };

    return { v$, model, localeSupportedOptions, fetch, beforeFetch, actions };
}
